import { render, staticRenderFns } from "./TypeDocumentMonthlyAdmin.vue?vue&type=template&id=b8da293e&"
import script from "./TypeDocumentMonthlyAdmin.vue?vue&type=script&lang=js&"
export * from "./TypeDocumentMonthlyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TypeDocumentMonthlyAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports